<div class="sites-map">

  <!-- Carte OL -->
  <div #mapContainer class="sites-map__container"></div>

  <!-- Popup carte générique — contenu site en content projection -->
  @if (mapReady()) {
    <app-popup-panel
      [map]="map"
      [position]="popupPosition()"
      [isOpen]="popupOpen()"
      (closed)="closePopup()"
      size="small"
      color="mint"
      variant="secondary"
      [offset]="[33, 0]"
    >
      <!-- Header -->
      <ng-container slot="header">
        {{ popupSite()?.label }}
      </ng-container>

      <!-- Body : infos du site -->
      @if (popupSite()) {
        <div class="site-popup-rows">
          <div class="site-popup-row">
            <span class="site-popup-label">Area</span>
            <span class="site-popup-value">{{ popupSite()!.area }}</span>
          </div>
          <div class="site-popup-row">
            <span class="site-popup-label">Site</span>
            <span class="site-popup-value">{{ popupSite()!.label }}</span>
          </div>
          <div class="site-popup-row">
            <span class="site-popup-label">Blast number</span>
            <span class="site-popup-value">{{ popupSite()!.numberBlasts }}</span>
          </div>
        </div>
      }

      <!-- Footer : bouton Open -->
      <ng-container slot="footer">
        <app-button
          label="Open"
          variant="primary"
          color="amarante"
          size="medium"
          [fullWidth]="true"
          [addIconRight]="true"
          (clicked)="siteClicked.emit(popupSite()!)"
          data-attr="sites-map-btn-open"
        >
          <img slot="icon-right" src="./../../assets/icon/new_icon/arrow-right.svg" />
        </app-button>
      </ng-container>
    </app-popup-panel>
  }

  <!-- Boutons Maps / Plan (haut droite) -->
  <div class="ol-map-controls">
    <button
      class="ol-map-control-btn"
      [class.active]="viewMode() === 'maps'"
      (click)="setViewMode('maps')"
      data-attr="sites-map-btn-maps"
    >
      <img width="16" height="16" src="assets/icon/new_icon/maps.svg" alt="Maps Icon" />
      Maps
    </button>

    <button
      class="ol-map-control-btn"
      [class.active]="viewMode() === 'plan'"
      (click)="setViewMode('plan')"
      data-attr="sites-map-btn-plan"
    >
      <img width="16" height="16" src="assets/icon/new_icon/plan.svg" alt="Plan Icon" />
      Plan
    </button>
  </div>

  <!-- Scale bar custom (bas gauche) -->
  <div class="custom-scale-line">
    <span #scaleText class="scale-text">-- m</span>
    <div #scaleBar class="scale-bar"></div>
  </div>

  <!-- Bas droite : coordonnées + zoom côte à côte -->
  <div class="bottom-right-widgets">

    <!-- Coordonnées : EPSG / X / Y — mis à jour via pointermove OL -->
    @if (device.isDesktop()) {
      <div class="mouse-position-box">
        <span class="coord-line">{{ coordLabel() }}</span>
        <span class="coord-line">X: {{ coordX() }}</span>
        <span class="coord-line">Y: {{ coordY() }}</span>
      </div>
    }

    <!-- Zoom custom (boutons Angular, pas un contrôle OL) -->
    <div class="custom-zoom">
      <button type="button" title="Zoom in"  (click)="zoomIn()" data-attr="sites-map-btn-zoom-in">
        <img src="assets/icon/new_icon/zoom_in.svg"  width="16" height="16" alt="+" />
      </button>
      <button type="button" title="Zoom out" (click)="zoomOut()" data-attr="sites-map-btn-zoom-out">
        <img src="assets/icon/new_icon/zoom_out.svg" width="16" height="16" alt="−" />
      </button>
    </div>

  </div>

</div>